// mobile menu open
function mobileMenuFunc() {
    let MobileMenuBtn = document.querySelector('.js-mobile-menu-button');
    let MobileMenu = document.querySelector('.mobile-menu');
    let headerHeight = document.querySelector('.header').offsetHeight;
    MobileMenu.style.top = `${headerHeight + 0}px`;
    MobileMenu.style.height = `calc(100% - ${headerHeight}px)`;
    MobileMenuBtn.addEventListener('click',function () {
        MobileMenuBtn.classList.toggle('is-active');
        MobileMenu.classList.add('pre-open');
        if(MobileMenu.classList.contains('open')){
            setTimeout(function () {
                MobileMenu.classList.remove('pre-open');
            },600)
        }
        setTimeout(function () {
            MobileMenu.classList.toggle('open');
            document.querySelector('body').classList.toggle('no-scroll');
            document.querySelector('html').classList.toggle('no-scroll');
        },100)
    });

    // let submenuOpen = document.querySelector('.js-submenu-open-btn');
    // submenuOpen.addEventListener('click',()=>{submenuOpen.querySelector('.header-submenu').classList.toggle('open')});
};
mobileMenuFunc();